import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17f1cca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "職歴を教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "現在、もしくは直近の所属会社からご入力ください", -1))
const _hoisted_5 = { class: "entry_career_title" }
const _hoisted_6 = { class: "entry_career_title_text" }
const _hoisted_7 = { class: "entry_career_text" }
const _hoisted_8 = { class: "entry_career_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "会社名・団体名"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_10 = { class: "entry_career_input_text" }
const _hoisted_11 = { class: "entry_career_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "業種"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/102",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）業種一覧 ")
], -1))
const _hoisted_13 = { class: "entry_career_input_text" }
const _hoisted_14 = { class: "entry_career_input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "社員数")
], -1))
const _hoisted_16 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_17 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_18 = { class: "entry_base_input_item_text_column_2_inner" }
const _hoisted_19 = { class: "entry_base_input_item_text_column_2_inner_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_input_item_text_column_2_inner_suffix_text" }, "人")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_right" }, null, -1))
const _hoisted_22 = {
  key: 2,
  class: "entry_career_input"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "在籍状況"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_24 = { class: "entry_base_input_item_radio_column_2" }
const _hoisted_25 = { class: "entry_career_input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "在籍期間"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_27 = { class: "entry_career_input" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "職種（3つまで選択できます）"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.massmedian.co.jp/information/view/101",
    class: "text_link_outbound input_title_link",
    target: "_blank"
  }, " ※（参考）職種一覧 ")
], -1))
const _hoisted_29 = { class: "entry_career_input_text" }
const _hoisted_30 = { class: "entry_career_input" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "雇用形態"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_32 = { class: "entry_base_input_item_radio_column_2" }
const _hoisted_33 = { class: "entry_base_input_item_radio_column_2" }
const _hoisted_34 = { class: "entry_base_input_item_radio_column_2" }
const _hoisted_35 = { class: "entry_career_input" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "役職")
], -1))
const _hoisted_37 = { class: "entry_career_input_text" }
const _hoisted_38 = { class: "entry_career_input" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "年収")
], -1))
const _hoisted_40 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_41 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_42 = { class: "entry_base_input_item_text_column_2_inner" }
const _hoisted_43 = { class: "entry_base_input_item_text_column_2_inner_input" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_input_item_text_column_2_inner_suffix_text" }, "万円")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_right" }, null, -1))
const _hoisted_46 = { class: "entry_career_input" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "月収")
], -1))
const _hoisted_48 = { class: "entry_base_input_item_text_column_2" }
const _hoisted_49 = { class: "entry_base_input_item_text_column_2_left" }
const _hoisted_50 = { class: "entry_base_input_item_text_column_2_inner" }
const _hoisted_51 = { class: "entry_base_input_item_text_column_2_inner_input" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_input_item_text_column_2_inner_suffix_text" }, "万円")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_input_item_text_column_2_right" }, null, -1))
const _hoisted_54 = { class: "entry_career_input" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "職務内容（2000文字まで）")
], -1))
const _hoisted_56 = { class: "entry_career_input_textarea" }
const _hoisted_57 = { class: "textarea" }
const _hoisted_58 = { class: "entry_career_button" }
const _hoisted_59 = { class: "entry_career_button_prev" }
const _hoisted_60 = { class: "entry_career_button_next" }

import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import store from '@/store';
import {
  getMasterDataListWkStatus,
  getMasterDataListEmpTypeBusicr,
  getMasterDataListIndsctg,
  getMasterDataOcupClass,
  MasterEmpTypeBusicr,
  MasterDataWkStatus,
} from '@/api/masterDataEndpoint';

import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import EditRadioModal from '@/components/EditRadioModal.vue';
import EditCheckboxModal from '@/components/EditCheckboxModal.vue';
import { RadioListType, CheckboxListType } from '@/types';

import ErrorMessage from '@/components/ErrorMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

const wkStatusId = ref(0); // 在籍期間フォームの出し分けに使用 apiには送信しないデータ
const wkStatusList = ref<MasterDataWkStatus[]>([]);
const empTypeBusicrList = ref<MasterEmpTypeBusicr[]>([]);
const masterDataIndsctg = ref<RadioListType[]>([]);
const masterDataOcupClass = ref<CheckboxListType[]>([]);

const isLoading = ref(false);

const workHistoryDetailInfo = ref(store.getters['entryCareerCompany/workHistoryDetailInfo']);

const init = async () => {
  isLoading.value = true;
  try {
    // 追加時
    if (store.getters['entryCareerCompany/editingBusicrId'] === null) {
      store.commit('entryCareerCompany/setNewWorkHistoryDetailInfo');
    } else {
      // 編集時
      await store.dispatch('entryCareerCompany/getWorkHistoryDetailInfo', store.getters['entryCareerCompany/editingBusicrId']);
      compname.value = workHistoryDetailInfo.value.compname;
    }
    const [resMasterDataListWkStatus, resMasterDataListEmpTypeBusicr, resMasterDataIndsctg, resMasterDataOcupClass] = await Promise.all([
      getMasterDataListWkStatus(),
      getMasterDataListEmpTypeBusicr(),
      getMasterDataListIndsctg(),
      getMasterDataOcupClass(),
    ]);

    workHistoryDetailInfo.value = store.getters['entryCareerCompany/workHistoryDetailInfo'];
    compname.value = workHistoryDetailInfo.value.compname;
    indsctgId.value = workHistoryDetailInfo.value.indsctgId;
    employeeNum.value = workHistoryDetailInfo.value.employeeNum ? workHistoryDetailInfo.value.employeeNum.toString() : null;
    wkperiodsDateyr.value = workHistoryDetailInfo.value.wkperiodsDateyr;
    wkperiodsDatemon.value = workHistoryDetailInfo.value.wkperiodsDatemon;
    wkperiodeDateyr.value = workHistoryDetailInfo.value.wkperiodeDateyr;
    wkperiodeDatemon.value = workHistoryDetailInfo.value.wkperiodeDatemon;
    busicrOcupctg1Id.value = workHistoryDetailInfo.value.busicrOcupctg1Id;
    busicrOcupctg2Id.value = workHistoryDetailInfo.value.busicrOcupctg2Id;
    busicrOcupctg3Id.value = workHistoryDetailInfo.value.busicrOcupctg3Id;
    emptypeId.value = workHistoryDetailInfo.value.emptypeId;
    post.value = workHistoryDetailInfo.value.post;
    annualincm.value = workHistoryDetailInfo.value.annualincm ? workHistoryDetailInfo.value.annualincm.toString() : null;
    salary.value = workHistoryDetailInfo.value.salary ? workHistoryDetailInfo.value.salary.toString() : null;
    wkcontents.value = workHistoryDetailInfo.value.wkcontents ? workHistoryDetailInfo.value.wkcontents : '';
    selectedOccupationValues.value = [
      busicrOcupctg1Id.value ? busicrOcupctg1Id.value : '',
      busicrOcupctg2Id.value ? busicrOcupctg2Id.value : '',
      busicrOcupctg3Id.value ? busicrOcupctg3Id.value : '',
    ].filter((x) => x !== '');

    // 在籍状況チェック処理を挟む
    if (wkperiodeDateyr.value && wkperiodeDatemon.value) {
      wkStatusId.value = 2;
    } else if (wkperiodsDateyr.value && wkperiodsDatemon.value) {
      wkStatusId.value = 1;
    }

    wkStatusList.value = resMasterDataListWkStatus;
    empTypeBusicrList.value = resMasterDataListEmpTypeBusicr;
    masterDataIndsctg.value = resMasterDataIndsctg.map((i) => {
      return {
        type: 'default',
        label: i.indsctgLargeName,
        value: i.indsctgLargeId,
        children: i.mstIndsctgSmallDataList.map((j) => {
          return {
            type: 'radio',
            label: j.indsctgSmallName,
            value: j.indsctgSmallId,
          };
        }),
      };
    });
    masterDataOcupClass.value = resMasterDataOcupClass.map((i) => {
      return {
        type: 'default',
        label: i.ocup1ClassName,
        value: i.ocup1ClassId,
        children: i.mstOcup2ClassDataList.map((j) => {
          return {
            type: 'default',
            label: j.ocup2ClassName,
            value: j.ocup2ClassId,
            children: j.mstOcup3ClassDataList.map((k) => {
              return {
                type: 'checkbox',
                label: k.ocup3ClassName,
                value: k.ocup3ClassId,
              };
            }),
          };
        }),
      };
    });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const shownIndustryModal = ref(false);
const openIndustryModal = () => (shownIndustryModal.value = true);
const closeIndustryModal = () => (shownIndustryModal.value = false);
const clearIndustry = () => {
  indsctgId.value = '';
};
const shownOccupationModal = ref(false);
const openOccupationModal = () => (shownOccupationModal.value = true);
const closeOccupationModal = () => (shownOccupationModal.value = false);
const clearOccupation = () => {
  selectedOccupationValues.value = [];
};

// 選択した業種の値に該当するテキストを設定する
const industryTextList = computed(() => {
  return masterDataIndsctg.value.map((i) => i.children).flat();
});
const selectedIndustryText = computed(() => {
  if (indsctgId.value === null) return '';
  return (
    industryTextList.value.filter((i) => {
      return Number(i?.value) === Number(indsctgId.value);
    })[0]?.label || ''
  );
});
// 選択した職種の値に該当するテキストを設定する
const occupationTextList = computed(() => {
  return masterDataOcupClass.value.map((i) => i.children?.map((j) => j.children)).flat(2);
});
const selectedOccupationText = computed(() => {
  let createTextList = [];
  for (let index = 0; index < selectedOccupationValues.value.length; index++) {
    const createText = occupationTextList.value.find((v) => {
      if (v !== undefined) {
        return v.value === selectedOccupationValues.value[index];
      }
    })?.label;
    createTextList.push(createText);
  }
  return createTextList.join('、');
});

const { meta, errors } = useForm();
const { value: compname } = useField<string>('compname', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.compname,
  bails: false,
  label: '会社名・団体名',
});
const { value: indsctgId } = useField<string>('indsctgId', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.indsctgId,
  bails: false,
  label: '業種',
});
const { value: employeeNum } = useField<string>('employeeNum', validationRuleHelper({ betweenValue: [1, 999999] }), {
  initialValue: workHistoryDetailInfo.value.employeeNum ? workHistoryDetailInfo.value.employeeNum.toString() : null,
  bails: false,
  label: '社員数',
});
const { value: wkperiodsDateyr } = useField<string>('wkperiodsDateyr', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.wkperiodsDateyr,
  bails: false,
  label: '在籍期間',
});
const { value: wkperiodsDatemon } = useField<string>('wkperiodsDatemon', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.wkperiodsDatemon,
  bails: false,
  label: '在籍期間',
});
const { value: wkperiodeDateyr } = useField<string | null>('wkperiodeDateyr', undefined, {
  initialValue: workHistoryDetailInfo.value.wkperiodeDateyr,
});
const { value: wkperiodeDatemon } = useField<string | null>('wkperiodeDatemon', undefined, {
  initialValue: workHistoryDetailInfo.value.wkperiodeDatemon,
});
const { value: busicrOcupctg1Id } = useField<string>('busicrOcupctg1Id', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.busicrOcupctg1Id,
  bails: false,
  label: '職種',
});
const { value: busicrOcupctg2Id } = useField<string | null>('busicrOcupctg2Id', undefined, {
  initialValue: workHistoryDetailInfo.value.busicrOcupctg2Id,
});
const { value: busicrOcupctg3Id } = useField<string | null>('busicrOcupctg3Id', undefined, {
  initialValue: workHistoryDetailInfo.value.busicrOcupctg3Id,
});
const { value: emptypeId } = useField<number>('emptypeId', validationRuleHelper({ required: true }), {
  initialValue: workHistoryDetailInfo.value.emptypeId,
  label: '雇用形態',
});
const { value: post } = useField<string>('post', undefined, {
  initialValue: workHistoryDetailInfo.value.post,
  bails: false,
  label: '役職',
});
const { value: annualincm } = useField<string>('annualincm', validationRuleHelper({ betweenValue: [1, 9999] }), {
  initialValue: workHistoryDetailInfo.value.annualincm ? workHistoryDetailInfo.value.annualincm.toString() : null,
  bails: false,
  label: '年収',
});
const { value: salary } = useField<string>('salary', validationRuleHelper({ betweenValue: [1, 9999] }), {
  initialValue: workHistoryDetailInfo.value.salary ? workHistoryDetailInfo.value.salary.toString() : null,
  bails: false,
  label: '月収',
});
const { value: wkcontents } = useField<string>('wkcontents', validationRuleHelper({ max: 2000 }), {
  initialValue: workHistoryDetailInfo.value.wkcontents ? workHistoryDetailInfo.value.wkcontents : '',
  bails: false,
  label: '職務内容',
});

const selectedOccupationValues = ref<string[]>(
  [
    busicrOcupctg1Id.value ? busicrOcupctg1Id.value : '',
    busicrOcupctg2Id.value ? busicrOcupctg2Id.value : '',
    busicrOcupctg3Id.value ? busicrOcupctg3Id.value : '',
  ].filter((x) => x !== '')
);

watch(selectedOccupationValues, () => {
  busicrOcupctg1Id.value = selectedOccupationValues.value[0];
  busicrOcupctg2Id.value = selectedOccupationValues.value[1] || null;
  busicrOcupctg3Id.value = selectedOccupationValues.value[2] || null;
});

const wkperiodsDateConcat = computed({
  get: () => {
    if (wkperiodsDateyr.value === null || wkperiodsDatemon.value === null) {
      return '';
    }
    return `${wkperiodsDateyr.value}-${String('00' + wkperiodsDatemon.value).slice(-2)}`;
  },
  set: (value) => {
    if (value === '') {
      return;
    }
    const y = value.split('-')[0];
    const m = value.split('-')[1];
    wkperiodsDateyr.value = y;
    wkperiodsDatemon.value = m;
  },
});
const wkperiodeDateConcat = computed({
  get: () => {
    if (wkperiodeDateyr.value === null || wkperiodeDatemon.value === null) {
      return '';
    }
    return `${wkperiodeDateyr.value}-${String('00' + wkperiodeDatemon.value).slice(-2)}`;
  },
  set: (value) => {
    if (value === '') {
      return;
    }
    const y = value.split('-')[0];
    const m = value.split('-')[1];
    wkperiodeDateyr.value = y;
    wkperiodeDatemon.value = m;
  },
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c02' });
};
const transitionNextPage = async () => {
  isLoading.value = true;
  try {
    // 現職なら wkperiodeDateyr wkperiodeDatemon をnullにする
    if (wkStatusId.value === 1) {
      wkperiodeDateyr.value = null;
      wkperiodeDatemon.value = null;
    }
    const setValue = {
      compname: compname.value,
      indsctgId: Number(indsctgId.value),
      employeeNum: employeeNum.value ? Number(employeeNum.value) : null,
      wkperiodsDateyr: Number(wkperiodsDateyr.value),
      wkperiodsDatemon: Number(wkperiodsDatemon.value),
      wkperiodeDateyr: wkperiodeDateyr.value ? Number(wkperiodeDateyr.value) : null,
      wkperiodeDatemon: wkperiodeDatemon.value ? Number(wkperiodeDatemon.value) : null,
      busicrOcupctg1Id: selectedOccupationValues.value[0] ? selectedOccupationValues.value[0] : null,
      busicrOcupctg2Id: selectedOccupationValues.value[1] ? selectedOccupationValues.value[1] : null,
      busicrOcupctg3Id: selectedOccupationValues.value[2] ? selectedOccupationValues.value[2] : null,
      emptypeId: Number(emptypeId.value),
      post: post.value,
      annualincm: annualincm.value ? Number(annualincm.value) : null,
      salary: salary.value ? Number(salary.value) : null,
      wkcontents: wkcontents.value,
    };
    store.commit('entryCareerCompany/setEditingWorkHistoryDetailInfo', setValue);
    await store.dispatch('entryCareerCompany/putWorkHistoryDetailInfo');
    router.push({ name: 'c04' });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Indicator, {
            current: 4,
            max: 12
          })
        ]),
        (workHistoryDetailInfo.value.busicrId === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _hoisted_4
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h1", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, "職歴" + _toDisplayString(workHistoryDetailInfo.value.busicrId) + "を教えてください", 1)
              ]),
              _createElementVNode("p", _hoisted_7, "「職歴" + _toDisplayString(workHistoryDetailInfo.value.busicrId - 1) + "」の前職の所属会社をご入力ください", 1)
            ], 64)),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(compname),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(compname) ? (compname).value = $event : null)),
              placeholder: "会社名・団体名",
              maxlength: 50,
              isError: !!_unref(errors).compname
            }, null, 8, ["modelValue", "isError"])
          ]),
          (_unref(errors).compname)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).compname]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(BaseSelectButton, {
              placeholder: "業種を選択",
              modelValue: _unref(selectedIndustryText),
              onClick: openIndustryModal,
              onClear: clearIndustry,
              isError: !!_unref(errors).indsctgId
            }, null, 8, ["modelValue", "isError"])
          ]),
          (_unref(errors).indsctgId)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).indsctgId]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(BaseTextForm, {
                    modelValue: _unref(employeeNum),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(employeeNum) ? (employeeNum).value = $event : null)),
                    placeholder: "社員数を入力",
                    maxlength: 6,
                    isError: !!_unref(errors).employeeNum
                  }, null, 8, ["modelValue", "isError"])
                ]),
                _hoisted_20
              ])
            ]),
            _hoisted_21
          ]),
          (_unref(errors).employeeNum)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).employeeNum]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        (workHistoryDetailInfo.value.busicrId === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wkStatusList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.code,
                    class: _normalizeClass(index % 2 === 0 ? 'entry_base_input_item_radio_column_2_left' : 'entry_base_input_item_radio_column_2_right')
                  }, [
                    _createVNode(BaseRadioButton, {
                      modelValue: wkStatusId.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((wkStatusId).value = $event)),
                      value: item.code,
                      name: "enrolled",
                      label: item.name
                    }, null, 8, ["modelValue", "value", "label"])
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          (wkStatusId.value === 1 && workHistoryDetailInfo.value.busicrId === 1)
            ? (_openBlock(), _createBlock(BaseYmForm, {
                key: 0,
                yearSort: "desc",
                modelValue: _unref(wkperiodsDateConcat),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(wkperiodsDateConcat) ? (wkperiodsDateConcat).value = $event : null)),
                suffixYearText: "年",
                suffixMonthText: "月から現在"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (wkStatusId.value === 2 || workHistoryDetailInfo.value.busicrId !== 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(BaseYmForm, {
                  yearSort: "desc",
                  modelValue: _unref(wkperiodsDateConcat),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(wkperiodsDateConcat) ? (wkperiodsDateConcat).value = $event : null)),
                  suffixYearText: "月",
                  suffixMonthText: "月から"
                }, null, 8, ["modelValue"]),
                _createVNode(BaseYmForm, {
                  yearSort: "desc",
                  modelValue: _unref(wkperiodeDateConcat),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(wkperiodeDateConcat) ? (wkperiodeDateConcat).value = $event : null)),
                  suffixYearText: "月",
                  suffixMonthText: "月まで"
                }, null, 8, ["modelValue"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createVNode(BaseSelectButton, {
              placeholder: "職種を選択",
              modelValue: _unref(selectedOccupationText),
              onClick: openOccupationModal,
              onClear: clearOccupation,
              isError: !!_unref(errors).busicrOcupctg1Id
            }, null, 8, ["modelValue", "isError"])
          ]),
          (_unref(errors).busicrOcupctg1Id)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).busicrOcupctg1Id]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empTypeBusicrList.value.slice(0, 2), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.code,
                class: _normalizeClass(index % 2 === 0 ? 'entry_base_input_item_radio_column_2_left' : 'entry_base_input_item_radio_column_2_right')
              }, [
                _createVNode(BaseRadioButton, {
                  modelValue: _unref(emptypeId),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(emptypeId) ? (emptypeId).value = $event : null)),
                  value: item.code,
                  name: "employment_status",
                  label: item.name
                }, null, 8, ["modelValue", "value", "label"])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empTypeBusicrList.value.slice(2, 4), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.code,
                class: _normalizeClass(index % 2 === 0 ? 'entry_base_input_item_radio_column_2_left' : 'entry_base_input_item_radio_column_2_right')
              }, [
                _createVNode(BaseRadioButton, {
                  modelValue: _unref(emptypeId),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(emptypeId) ? (emptypeId).value = $event : null)),
                  value: item.code,
                  name: "employment_status",
                  label: item.name
                }, null, 8, ["modelValue", "value", "label"])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empTypeBusicrList.value.slice(4, 6), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.code,
                class: _normalizeClass(index % 2 === 0 ? 'entry_base_input_item_radio_column_2_left' : 'entry_base_input_item_radio_column_2_right')
              }, [
                _createVNode(BaseRadioButton, {
                  modelValue: _unref(emptypeId),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(emptypeId) ? (emptypeId).value = $event : null)),
                  value: item.code,
                  name: "employment_status",
                  label: item.name
                }, null, 8, ["modelValue", "value", "label"])
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(post),
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(post) ? (post).value = $event : null)),
              placeholder: "役職を入力",
              maxlength: 25,
              isError: !!_unref(errors).post
            }, null, 8, ["modelValue", "isError"])
          ]),
          (_unref(errors).post)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).post]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(BaseTextForm, {
                    modelValue: _unref(annualincm),
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(annualincm) ? (annualincm).value = $event : null)),
                    placeholder: "400",
                    maxlength: 4,
                    isError: !!_unref(errors).annualincm
                  }, null, 8, ["modelValue", "isError"])
                ]),
                _hoisted_44
              ])
            ]),
            _hoisted_45
          ]),
          (_unref(errors).annualincm)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).annualincm]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(BaseTextForm, {
                    modelValue: _unref(salary),
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(salary) ? (salary).value = $event : null)),
                    placeholder: "30",
                    maxlength: 4,
                    isError: !!_unref(errors).salary
                  }, null, 8, ["modelValue", "isError"])
                ]),
                _hoisted_52
              ])
            ]),
            _hoisted_53
          ]),
          (_unref(errors).salary)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).salary]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createVNode(BaseTextareaForm, {
                modelValue: _unref(wkcontents),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(wkcontents) ? (wkcontents).value = $event : null)),
                name: "otherFieldMemo",
                rows: 6,
                maxCount: 2000,
                placeholder: "入力してください"
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_unref(errors).wkcontents)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).wkcontents]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createVNode(BaseButton, {
              onClick: transitionPreviousPage,
              theme: "tertiary",
              type: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(BaseButton, {
              onClick: transitionNextPage,
              theme: "primary",
              type: "button",
              disabled: !_unref(meta).valid
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存して次へ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    (shownIndustryModal.value)
      ? (_openBlock(), _createBlock(EditRadioModal, {
          key: 0,
          title: "業種を選択",
          modelValue: _unref(indsctgId),
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(indsctgId) ? (indsctgId).value = $event : null)),
          list: masterDataIndsctg.value,
          onClose: closeIndustryModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true),
    (shownOccupationModal.value)
      ? (_openBlock(), _createBlock(EditCheckboxModal, {
          key: 1,
          title: "職種選択（3つまで）",
          modelValue: selectedOccupationValues.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedOccupationValues).value = $event)),
          list: masterDataOcupClass.value,
          selectableMinNumber: 1,
          selectableMaxNumber: 3,
          hasNextPageType: "",
          onClose: closeOccupationModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})